import { CustomerDirectory } from '../features/customer';

export default function CustomersPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <CustomerDirectory />
    </div>
  );
}
